// Used for IST Versteuerung
import { GQL } from "../index";
import { Bu } from "./Bu";
import { KontoNumUtils } from "./KontoNumUtils";
import { KontoDefaultLen } from "./InterfaceBase";
export class BuMNF {
    static set = new Set([Bu.BU2, Bu.BU3, 4, 5, 12, 13, 14, 15]);
    static isMNF = ({ taxation }, bu) => {
        return taxation === GQL.ICompanyTaxation.Ist && this.set.has(bu);
    };
    static isMNFLogicForBu = (config, bu, konto) => {
        if (!this.isMNF(config, bu)) {
            return false;
        }
        return this.isKontoMNF(config, konto);
    };
    static isMNFLogicForKonto = (config, konto) => {
        return config.taxation === "IST" && this.isKontoMNF(config, { extNum: konto });
    };
    static isKontoMNF({ kontoExt, skr }, konto) {
        if (!konto) {
            return false;
        }
        const kontoLen = konto?.stringNum?.length || konto?.extNum?.getExtNum(kontoExt).length || 0;
        const kontoDefaultLen = kontoLen - kontoExt;
        if (kontoDefaultLen === KontoDefaultLen.Category) {
            return (KontoNumUtils.isCategoryRepresentingDebitor(konto, skr, kontoExt) ||
                KontoNumUtils.isCategoryRepresentingCreditor(konto, skr, kontoExt));
        }
        if (kontoDefaultLen === KontoDefaultLen.Creditor) {
            return KontoNumUtils.isDebitor(konto, kontoExt) || KontoNumUtils.isCreditor(konto, kontoExt);
        }
        throw new Error("Invalid default konto len " + kontoDefaultLen + ", data: " + JSON.stringify(konto));
    }
}
//# sourceMappingURL=BuMNF.js.map